module.exports = __webpack_public_path__ + "009d359667439966576225ae1d918907.svg";